import * as React from 'react'

import { useRecoilValue } from 'recoil'

import routes from '../../../router/routes'
import { translate } from '../../../state/locale/selectors/translate'
import PageWrapper from '../../_layout/PageWrapper'
import { Error404 } from '../../organisms/404'
import Breadcrumbs from '../../reusable/Breadcrumbs'

const Error404Page = () => {
  const i18n = useRecoilValue(translate).errors.error404
  const breadcrumbs = [
    {
      link: routes.index,
      title: i18n.breadcrumb,
    },
  ]

  return (
    <PageWrapper>
      <Breadcrumbs base={breadcrumbs} />
      <Error404 />
    </PageWrapper>
  )
}

export default Error404Page
